import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import fr from './fr.json';

const resources = { fr };

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    debug: false,
    defaultNS: 'localized-strings',
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    },
    keySeparator: '.',
    lng: 'fr',
  });

export default i18n;
export { fr };
